<div class="seed-return-add-prod" style="position: relative">
  <div class="prod-top-sec">
    <h3 class="margin-l15">
      Retail Alliance Low Net Cost Sheet - Glossary
    </h3>
  </div>
  <div class="addBorder">

    <element *ngFor="let headerGlossary of noticeData">
      <p><b>{{headerGlossary.headerValue}}: </b>{{headerGlossary.detailValue}}</p>
    </element>

    <element *ngFor="let detailGlossary of glossaryData">
      <p><b>- {{detailGlossary.headerValue}}: </b>{{detailGlossary.detailValue}}</p>
    </element>
  </div>
</div>
